import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import Link from "components/Shared/Link";

type Props = {
  description: string;
  href: string;
  IconComponent: IconType;
  title: string;
};

export default function ResourceLink({
  description,
  href,
  IconComponent,
  title,
}: Props) {
  return (
    <Link
      isExternal
      href={href}
      display="flex"
      alignItems="center"
      gap={3}
      p={2}
      borderRadius="md"
      _hover={{ background: "white", boxShadow: "sm", textDecoration: "none" }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        boxSize={8}
        borderRadius="md"
        background="lightPink"
        color="pink.50"
        flexShrink={0}
      >
        <Icon as={IconComponent} boxSize={4} />
      </Flex>

      <Box minWidth={0}>
        <Text color="magenta.veryDark" fontSize="xs" fontWeight="700">
          {title}
        </Text>
        <Text color="gray.500" fontSize="xs" noOfLines={1}>
          {description}
        </Text>
      </Box>
    </Link>
  );
}
